import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { borderRadius as borderRadiusFn, gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { itemActiveBackgroundColor, itemHoverBackgroundColor, itemTextColor, itemTextSelectedColor, navigationBackgroundColor } from './constants';
var gridSize = gridSizeFn();
var borderRadius = borderRadiusFn();
var itemIconSize = gridSize * 3;
var leftIconRightSpacing = gridSize * 2;
export var ITEM_SIDE_PADDING = gridSize * 1.25;
/**
 * Allows chaining of style functions on top of base style functions
 * @param baseStyle the base custom cssFn
 * @param newStyle a new cssFn to be applied after the base style
 */

export var overrideStyleFunction = function overrideStyleFunction(baseStyle) {
  var newStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (css) {
    return css;
  };
  return function (css, state) {
    return newStyle(baseStyle(css, state), state);
  };
};
export var baseSideNavItemStyle = function baseSideNavItemStyle(currentStyles, _ref) {
  var isSelected = _ref.isSelected,
      isDisabled = _ref.isDisabled;
  var backgroundColor = navigationBackgroundColor;
  var color = itemTextColor;

  if (isSelected) {
    backgroundColor = itemHoverBackgroundColor;
    color = itemTextSelectedColor;
  }

  if (isDisabled) {
    backgroundColor = "".concat(navigationBackgroundColor, " !important");
  }

  return _objectSpread(_objectSpread({}, currentStyles), {}, _defineProperty({
    // This padding is set to ensure that the center of the left icon
    // is approximately center aligned with the horizontal app switcher.
    padding: "".concat(gridSize, "px ").concat(ITEM_SIDE_PADDING, "px"),
    borderRadius: borderRadius,
    backgroundColor: backgroundColor,
    color: color,
    '&:hover': {
      backgroundColor: itemHoverBackgroundColor,
      textDecoration: 'none',
      color: color
    },
    '&:active': {
      color: itemTextSelectedColor,
      backgroundColor: itemActiveBackgroundColor,
      boxShadow: 'none'
    }
  }, '& [data-item-elem-before]', {
    // center align icons with app-switcher regardless of size
    display: 'flex',
    height: itemIconSize,
    width: itemIconSize,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: leftIconRightSpacing
  }));
};
export var backItemStyle = function backItemStyle(currentStyles, _) {
  return _objectSpread(_objectSpread({}, currentStyles), {}, {
    '&:hover': {
      backgroundColor: itemHoverBackgroundColor
    }
  });
};
export var sectionHeaderStyle = function sectionHeaderStyle(currentStyles) {
  return _objectSpread(_objectSpread({}, currentStyles), {}, {
    paddingLeft: "".concat(ITEM_SIDE_PADDING, "px"),
    paddingRight: "".concat(ITEM_SIDE_PADDING, "px")
  });
};